import React from 'react';
import { findNearestElementMatchingTags } from '../../utils/dom';
import { trackEvent } from '../../api/analytics/google';
import { connect } from 'react-redux';
import { getUiBase } from '../../api/redux-watson/watson-config-selectors';
import { noticeError } from 'app/api/analytics/reporting';

class ClickTracker extends React.Component {
  boundClickHandler = this.clickHandler.bind(this);

  componentDidMount() {
    window.addEventListener('click', this.boundClickHandler, true);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.boundClickHandler, true);
  }

  clickHandler(e) {
    try {
      const el = findNearestElementMatchingTags(e.target, ['a', 'button']);
      if (el && !el.disabled) {
        const msgEl = el.querySelector('[data-msg-id]');
        let msg;
        if (msgEl) {
          msg = msgEl.getAttribute('data-msg-id');
        }

        const category = el.getAttribute('data-ga-category') || 'clicks';
        const action = el.getAttribute('data-ga-action') || msg;
        const label = el.getAttribute('data-ga-label');
        const value = el.getAttribute('data-ga-value');

        trackEvent(
          `${category}/${this.props.uiBase || 'unknown'}`,
          action,
          label,
          value
        );
      }
    } catch (e) {
      noticeError(e);
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  uiBase: getUiBase(state),
});

export default connect(mapStateToProps)(ClickTracker);



// WEBPACK FOOTER //
// ./src/app/ui/analytics/ClickTracker.js